import React from "react";
import { TextField, IconButton } from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";

function OptionRow({ qid, option, onCommit, onDelete, classes }) {
  const [value, setValue] = React.useState(option?.secundario?.nombre ?? "");

  React.useEffect(() => {
    setValue(option?.secundario?.nombre ?? "");
  }, [option?.id]);

  return (
    <div className={classes.optionRow} key={`row-${option.id}`}>
      <TextField
        className={classes.optionInput}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={() => onCommit(qid, option.id, value)}
        variant="outlined"
        size="small"
      />
      <IconButton onClick={() => onDelete(qid, option.id)} title="Eliminar opción">
        <DeleteIcon />
      </IconButton>
    </div>
  );
}

export default React.memo(OptionRow);
